<template>
	<div class="cooperation-container">
		<h1>{{ $t('cooperation.title') }}</h1>
		<p class="description">{{ $t('cooperation.description') }}</p>

		<div class="cooperation-grid">
			<!-- 线下体验店 -->
	<!-- 		<div class="cooperation-item" @click="gotoPage1()">
				<img src="../assets/home/home_xianxia.png" alt="线下体验店" />
				<h2>{{ $t('cooperation.offlineStore.title') }}</h2>
				<p>{{ $t('cooperation.offlineStore.description') }}</p>
			</div> -->

			<!-- 招商加盟 -->
			<div class="cooperation-item" @click="gotoPage2()">
				<img src="../assets/home/home_jiameng.png" alt="招商加盟" />
				<h2>{{ $t('cooperation.businessInvestment.title') }}</h2>
				<p>{{ $t('cooperation.businessInvestment.description') }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CooperationSection',
	methods: {
		gotoPage1() {
			this.$router.push('/support');
		},
		gotoPage2() {
			this.$router.push('/contactus');
		}
	}
};
</script>

<style scoped>
.cooperation-container {
	padding: 40px 18px;
	text-align: center;
	max-width: 1200px;
	margin: 0 auto;
}

h1 {
	font-size: 2.5rem;
	color: #333;
	margin-bottom: 30px;
}

.description {
	font-size: 19px;
	color: #666;
	max-width: 800px;
	margin: 0 auto 40px;
	line-height: 1.6;
	margin-bottom: 35px;
}

.cooperation-grid {
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	gap: 30px;
}

.cooperation-item {
	flex: 1;
	min-width: 300px;
	max-width: 500px;
	text-align: left;
	overflow: hidden;
	transition: transform 0.3s ease;
}

.cooperation-item:hover {
	transform: translateY(-5px);
}

.cooperation-item img {
	width: 100%;
	border-radius: 12px;
	aspect-ratio: 580/180;
	object-fit: cover;
}

.cooperation-item h2 {
	font-size: 1.5rem;
	margin: 10px 15px 0px;
	color: #333;
}

.cooperation-item p {
	font-size: 1rem;
	color: #666;
	padding: 0 15px 15px;
	line-height: 1.4;
}
</style>
